import { Component } from '@angular/core';

@Component({
  selector: 'app-gift-box-icon',
  imports: [],
  templateUrl: './gift-box-icon.html',
  styleUrl: './gift-box-icon.scss'
})
export class GiftBoxIcon {

}
